import EditPageContainer from '@app/components/EditPageContainer'
import { BrokeragePipeline } from '@app/models/BrokeragePipeline'
import { bindFunctions } from '@app/utils/class'
import * as qs from 'query-string'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import {
  actionCreators,
  IPipelineEditState,
} from '@app/components/PipelineEdit/modules/pipelineEdit'
import './PipelineEditPage.scss'
import PipelineEdit from '@app/components/PipelineEdit'

type PipelineEditProps = IPipelineEditState &
  typeof actionCreators &
  RouteComponentProps<{ id?: string }>

export default class PipelineEditPage extends React.PureComponent<
  PipelineEditProps
> {
  constructor(props: PipelineEditProps) {
    super(props)
    bindFunctions(this)
  }

  public componentDidMount() {
    const query = qs.parse(this.props.location.search)
  }

  public componentWillUnmount() {
    this.props.resetState()
  }

  public render() {
    return (
      <EditPageContainer
        saveDisabled={false}
        title={
          this.props.match.params.id
            ? `${this.props.pipeline.name} :: Edit`
            : 'New Listing'
        }
        onSaveClick={this._onSave}
        onCancelClick={this._onCancel}
      >
        <PipelineEdit
          listingId={
            qs.parse(this.props.location.search).listingId as string | null
          }
          pipelineId={this.props.match.params.id}
        />
      </EditPageContainer>
    )
  }

  private _onCancel() {
    this.props.history.goBack()
  }

  private _onSave() {
    this.props.savePipeline(this.props.pipeline as BrokeragePipeline)
  }
}
